module.exports = __webpack_public_path__ + "img/U1F61C.d5f80d53.png";